import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NotificationPopupModalComponent } from './notification-popup-modal.component'
import { SharedPipesModule } from '../../shared/pipes/shared-pipes.module';

@NgModule({
  imports: [
    CommonModule,
    SharedPipesModule
  ],
  declarations: [
    NotificationPopupModalComponent
  ],
  exports: [
    NotificationPopupModalComponent
  ]
})
export class NotificationPopupModalModule { }
